import enviro from 'enviro';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { Environment } from '../types/Environment';
export const getIsQa = enviro.isQa;
export const isQA = enviro.isQa();
export const isLocal = isQA && !enviro.deployed();
export const isProd = enviro.isProd();
export const getHubSpotDomain = () => {
  return enviro.isQa() ? 'hubspotqa.com' : 'hubspot.com';
};
export const getDomainSuffix = () => {
  return enviro.isQa() ? Environment.QA : '';
};
export const getCurrentDomain = () => {
  const prefix = !enviro.deployed() ? Environment.Local : 'app';
  return `https://${prefix}.${getHubSpotDomain()}`;
};
export const getApplicationDomain = (hublet = HubletOption.na1) => {
  const prefix = !enviro.deployed() && enviro.isQa() ? Environment.Local : 'app';
  const subdomain = hublet === HubletOption.na1 ? prefix : `${prefix}-${hublet}`;
  return `https://${subdomain}.${getHubSpotDomain()}`;
};
export const getEnv = () => {
  if (!enviro.deployed()) return Environment.Local;
  return enviro.isQa() ? Environment.QA : Environment.Prod;
};